
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1mMWQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4ce9c9788c029867762cd394d7428d0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fedd0971d939a46$var$_react = $0fedd0971d939a46$var$_interopRequireDefault((parcelRequire("42omo")));

var $0fedd0971d939a46$var$_baseNew = $0fedd0971d939a46$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0fedd0971d939a46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Editor action for reviewing text
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fedd0971d939a46$var$TextReviewIcon = (props)=>/*#__PURE__*/ $0fedd0971d939a46$var$_react.default.createElement($0fedd0971d939a46$var$_baseNew.default, Object.assign({
        name: "TextReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m15.002 13.934-1.061 1.06-2.121-2.12 1.06-1.062z"/><path fill="currentcolor" d="M12.25 10a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0m1.5 0a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0M4.5 7.25v1.5H1v-1.5zm0 5.25V14H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$0fedd0971d939a46$var$TextReviewIcon.displayName = 'TextReviewIcon';
var $0fedd0971d939a46$var$_default = module.exports.default = $0fedd0971d939a46$var$TextReviewIcon;

});


//# sourceMappingURL=text-review.ea46f1d5.js.map
